import { useLocation, useNavigate } from 'react-router-dom';
import { useGoal } from '../context/GoalContext';
import Button from '../components/Button';
import Card from '../components/Card';
import ProgressBar from '../components/ProgressBar';
import { formatCurrency, formatDate } from '../utils/calculations';
import styles from './ConfirmationScreen.module.css';

const ConfirmationScreen = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { getGoal, goal } = useGoal();

  const savedGoal = state?.goalId ? getGoal(state.goalId) : null;
  const displayGoal = savedGoal || goal;

  return (
    <div className={styles.screen}>
      <div className={styles.content}>
        <div className={styles.iconWrap}>
          <div className={styles.iconCircle}>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <path d="M10 18L15.5 23.5L26 13" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className={styles.ripple} />
        </div>

        <h1 className={styles.heading}>Goal created!</h1>
        <p className={styles.sub}>Your adventure starts here</p>

        <Card className={styles.goalPreview}>
          <div className={styles.goalHeader}>
            <div className={styles.goalEmoji}>
              {displayGoal.name?.includes('Japan') ? '🗾' :
               displayGoal.name?.includes('home') ? '🏡' :
               displayGoal.name?.includes('car') ? '🚗' :
               displayGoal.name?.includes('Vacation') ? '🏖️' : '🎯'}
            </div>
            <div>
              <p className={styles.goalName}>{displayGoal.name || 'My Goal'}</p>
              <p className={styles.goalTarget}>{formatCurrency(displayGoal.amount || 0)} by {formatDate(displayGoal.deadline) || '—'}</p>
            </div>
          </div>
          <ProgressBar current={0} target={displayGoal.amount || 1} height={10} />
          <p className={styles.goalProgress}>0% — just getting started</p>
        </Card>
      </div>

      <div className={styles.footer}>
        <Button
          label="View my goal"
          onClick={() => navigate(savedGoal ? `/goal/${savedGoal.id}` : '/')}
        />
        <button className={styles.homeLink} onClick={() => navigate('/')}>
          Back to home
        </button>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
